import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function driverLocationsReducer(state = initialState.driverLocations, action){
  switch(action.type) {
    case types.LOAD_DRIVER_LOCATIONS_SUCCESS:
       return {...action.driverLocations};
    default:
          return state;
  }
}
